export default {
      id: "oc-res-systemuser-usage",
      viewBox: "0 0 1134 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-systemuser",
      toString: function () {
        return this.url;
      }
    }